module.exports = __webpack_public_path__ + "img/no-img.880c1c7f.svg";